<ng-container *transloco="let t; read: 'document-list-saved-search'">
  <div class="saved-search__search-box">
    <xi-search-box
      [placeholder]="t('search')"
      (onChangeOverride)="onFilterItems($event.detail.searchText)"
      [value]="searchText"
    ></xi-search-box>
  </div>
  <div class="saved-search__search-filter-container">
    @for (text of filteredSearchTexts; track trackItems($index, text)) {
      <div class="saved-search__search-filter-item">
        <xi-checkbox
          [label]="text.name"
          [(checked)]="text.selected"
          color="CX"
          (onChange)="onToggleSearchItem()"
        ></xi-checkbox>
        <xi-dropdown
          [data]="[
            { title: t('copy-search'), id: 'copy', visual: 'copy' },
            {
              title: t('delete-search'),
              id: 'delete',
              visual: 'trash',
              disabled: !text.canDelete,
              tooltip: !text.canDelete ? { text: t('cannot-delete-in-use') } : undefined,
            },
          ]"
          type="icon"
          [internalProps]="{ iconButton: { icon: 'kabob' } }"
          (onValueChange)="onTextDropdownChange($event.detail.selected.id, text.value)"
        ></xi-dropdown>
      </div>
    }
    @if (filteredSearchTexts.length < 1) {
      <div class="saved-search__empty">
        @if (searchTexts.length > 0) {
          {{ t('no-search-terms-found') }}
        } @else {
          {{ t('no-search-terms-exist') }}
        }
      </div>
    }
  </div>
</ng-container>
